import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme, width, loading }) => css`
    align-items: center;
    background: ${theme.v2.colors.neutral.highPure};
    border-radius: 16px;
    color: ${theme.v2.colors.brand.primaryExtraDark};
    display: flex;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
    justify-content: center;
    height: ${loading ? '552px' : 'auto'};
    padding: 24px 32px;
    width: ${`calc(${width || 30}% - ${!width || width === 100 ? '0px' : '8px'})`};
    
    @media (max-width: ${theme.v2.breakpoints.md}) {
      border-radius: 0;
      width: 100%;
    }
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 36px;
    margin: 0 0 16px 0;
    text-align: center;
    color: ${theme.v2.colors.brand.primaryExtraDark};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.sm2};
      line-height: 27px;
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 24px;
    margin: 0 0 24px 0;
    text-align: center;
    color: ${theme.v2.colors.neutral.lowDark};
  `}
`;

export const AdvertisementImage = styled.img`
  border-radius: 16px;
  margin-bottom: 24px;
  width: 100%;
`;

export const CtaButtonWrapper = styled.div;

export const SkeletonWrapper = styled.div`
  ${({ theme, image }) => css`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 24px;
    justify-content: center;
    margin-top: ${image ? '34px' : '14px'};
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      gap: 16px;
      margin-top: 14px;
    }
  `}
`;

export const SkeletonTexts = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;
